import { render } from "./TableList.vue?vue&type=template&id=cf48892e&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"

import "./TableList.vue?vue&type=style&index=0&id=cf48892e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf48892e"]])

export default __exports__